import React, { Component, lazy, Suspense } from 'react';
import { Tabs, message, Button, Upload, Select, Popconfirm, notification,Spin} from 'antd';
import CarPicturesList from '../../CarAndCardPicsTab/CarPicturesList';
import { isShowLocalUploadButton } from '../../../../../utils/agent';
import { flatten, encrypt } from '../../../../../utils/index';
import api from '../../../../../utils/api'
import { getPicsClassify, deletePics, reUploadImage } from '@service/report';
import MaterialsTreeData from '../../TravelLicenseForm/MaterialsTreeData';
import RecycleList from '../../../RecycleList';
import { withRouter } from 'react-router-dom';
import UploadList from '../../../../../components/UploadList';
import RequestQueue from '@utils/RequestQueue'
import { Queue } from '@utils/queue';
import { checkImagePixelLimit } from '../../imageUploadCheck';
import { startUploadStatusReconcile, stopUploadStatusReconcile } from '../../uploadStatusReconciler';
import './style.scss';


const Media = lazy(() => import('../../s3Media'))

const { TabPane } = Tabs, { Option } = Select;

/**
 * 业务中心-照片取证
 */
class CarOrCardPic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            mediaCount: 0,
            photos: [],
            downloadBtnText: '下载文件',
            selectedLoss: '',
            lossers: [],
            isShowTreeData: false,
            activeKey: '',
            recycleVisible: false
        };
        this.localUploadHandledFiles = new WeakSet();
    }
    sortItem = {};

    tabClick = (activeKey) => {
        this.setState({
            activeKey
        })
        this._getPicsClassify();
    };
    // 获取音视频资源的总数
    getCount = (count) => {
        this.setState({
            mediaCount: count
        });
    };
    setPhotos = (tabKey, picList) => {
        const { photos } = this.state;

        this.setState({
            photos: photos.map(category => category.key === tabKey ? ({
                ...category,
                list: picList
            }) : category)
        });
    };
    _getPicsClassify(data = {}) {
        const { flowId } = this.props;
        const { selectedLoss } = this.state;
        const params = {
            flowId: data.flowId || flowId,
            lossId: selectedLoss
        };
        getPicsClassify(params).then(({ result: { list, lossers } }) => {
            this.setState({
                photos: list.map(category => ({
                    ...category,
                    list: flatten(category.secondTypes.map(item => item.pics)).map(item => ({ ...item, originalRotate: item.rotate })).sort((a, b) => a.sortIndex - b.sortIndex)
                })),
                lossers
            });
        });
    }
    componentDidMount() {
        const { flowId } = this.props;
        getPicsClassify({
            flowId: flowId
        }).then(({ result: { list, lossers } }) => {
            this.setState({
                photos: list.map(category => ({
                    ...category,
                    list: flatten(category.secondTypes.map(item => item.pics)).map(item => ({ ...item, originalRotate: item.rotate })).sort((a, b) => a.sortIndex - b.sortIndex)
                })),
                lossers,
                activeKey: list.length ? list[0].key : 'mediaList',
                selectedLoss: lossers.length ? lossers[0].lossId : ''
            });
        });
        window.addEventListener('message', this.receiveMessage, false);
       
    }
    componentWillUnmount() {
        stopUploadStatusReconcile();
        window.removeEventListener('message', this.receiveMessage, false);
    }

    receiveMessage = async (event) => {
        const data = event.data;
        if (data.eventName === 'refreshPicsClassify') {
            // 更新图片列表
            await this._getPicsClassify({ flowId: data.flowId });
        }
    };

    showTreeData = () => {
        const elements = document.getElementsByClassName('car_pics_list_div')
        for (let index = 0; index < elements.length; index++) {
            const element = elements[index];

            element.style.width = '59%'

        }
        this.setState({
            isShowTreeData: true
        })

    }
    hideTreeData = () => {
        const elements = document.getElementsByClassName('car_pics_list_div')
        for (let index = 0; index < elements.length; index++) {
            const element = elements[index];

            element.style.width = '100%'

        }
        this.setState({
            isShowTreeData: false
        })
    }

    openWindow = () => {
        const { flowId } = this.props;
        const url = `/photo/${window.btoa(flowId)}?token=${window.btoa(window.accessToken)}`
        window.open(`/iframe/${encodeURIComponent(url)}`)
    }


    /*
     * 下载文件
     * */
    handleDownLoad() {
        let _this = this;
        _this.setState({ downloadBtnText: '正在打包...' });
        let { currentReport } = this.props;
        api('/zipFileToFtp')
            .post({ reportId: currentReport._id })
            .then(response => {
                _this.setState({ downloadBtnText: '下载文件' })
                //https://192.168.1.65:60803/zip/new.zip
                let { errCode, result, errInfo } = response;
                if (errCode === 0) {
                    if (result && result.length > 0) {
                        _this.downloadFile(result)
                    } else {
                        message.warning('没有图片可供下载！')
                    }
                } else {
                    message.error(errInfo)
                }
                //window.open(window.location.origin+'/zip/reportPic.zip');
            });
    }
    downloadFile(url) {
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        } catch (e) {

        }
    }

    confirm = () => {
        const { currentAgent, flowId } = this.props;

        if (!flowId) {
            return
        }
        reUploadImage({
            flowId,
            agentId: currentAgent._id
        }).then(({ errCode, errInfo }) => {
            if (errCode == 0) {
                message.success(errInfo)
            } else {
                message.info(errInfo)
            }
        });
    }


    getImageBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    beforeLocalUpload = (file, fileList) => {
        if (this.localUploadHandledFiles.has(file)) return false;
        fileList.forEach(item => this.localUploadHandledFiles.add(item));
        this.validateAndUploadLocalPics(fileList).catch(error => {
            console.error('本地图片上传前校验失败', error);
            message.error('图片上传前校验失败，请重新选择图片');
        });
        return false;
    };

    validateAndUploadLocalPics = async (fileList) => {
        const validFiles = [];
        let failedCount = 0;

        for (const file of fileList) {
            let failureReason = '';
            if (!['image/jpeg', 'image/png'].includes(file.type)) {
                failureReason = `不支持的图片格式：${file.type || '未知格式'}，仅支持 JPEG、PNG`;
            } else if (file.size > 1024 * 1024 * 12) {
                failureReason = `图片大小为${(file.size / 1024 / 1024).toFixed(2)}MB，超过12MB限制`;
            } else {
                const pixelCheck = await checkImagePixelLimit(file);
                if (!pixelCheck.ok) failureReason = pixelCheck.reason;
            }

            if (failureReason) {
                file.status = 'error';
                file.failureReason = failureReason;
                failedCount += 1;
                message.error(`${file.name}：${failureReason}`);
            } else {
                validFiles.push(file);
            }
        }

        if (failedCount) message.error(`有${failedCount}张图片上传失败，请重新上传！`);
        if (!validFiles.length) return;

        message.success('图片正在上传！');
        return this.picsUpload(validFiles);
    };

    picsUpload = async (fileList) => {
        const { actions, currentAgent, flowId } = this.props;
        const { picsUpload = {} } = this.state;
        // const label = currentAgent.tenant.code === 15 ? 'IDPhotos' : ''
        // const subLabel = currentAgent.tenant.code === 15 ? 'damageDetail' : ''
        const label = 'Local';
        const subLabel = 'localEtc';
            const queue = new Queue();
            window.fileListQueue = queue;
            queue.enqueue(fileList.map(item => ({ file: item, asyncStatus: '' })))
            const list = queue.getList();
            const request = async (i) => {
                let image;
                try {
                    image = await this.getImageBase64(list[i].file)
                } catch (error) {
                    return {
                        error: true,
                        payload: {
                            result: {
                                uid: list[i].file.uid,
                                failureReason: `图片上传前处理失败${error && error.message ? `：${error.message}` : ''}`,
                            },
                        },
                    };
                }
                return actions.uploadPic({
                    image,
                    flowId,
                    lossId: '',
                    label,
                    subLabel,
                    agentId: currentAgent._id,
                    isDone: i < 10 ? i === list.length - 1 : i % 10 === 0,
                    uid: list[i].file.uid
                })
            };

            let requestList = [];

            const instance = new RequestQueue();
            const callBack = (doneCount, result) => {
                const uploadResult = result && result.payload && result.payload.result || {};
                const uid = uploadResult.uid;
                // console.log(newFileList)
                // console.log(uid)
                const curIndex = list.findIndex(item => item.file.uid == uid);
                if (curIndex < 0) {
                    return;
                }
                const currentItem = queue.getList()[curIndex];
                const isTerminalStatus = ['success', 'fail', 'error'].includes(currentItem.asyncStatus);
                // const curData = list[curIndex]
                // curData.asyncStatus = result.error ? 'error' : 'uploading';
                console.log('上传开始', list)
                queue.update(curIndex, {
                    ...currentItem,
                    asyncStatus: isTerminalStatus ? currentItem.asyncStatus : result.error ? 'error' : 'uploading',
                    picId: isTerminalStatus ? currentItem.picId : uploadResult.picId || currentItem.picId,
                    failureReason: isTerminalStatus
                        ? currentItem.failureReason
                        : result.error ? uploadResult.failureReason || '图片上传失败，服务端未返回具体原因' : '',
                    httpStatus: isTerminalStatus ? currentItem.httpStatus : uploadResult.httpStatus,
                });
                let newList = queue.getList();
                console.log('上传完成', newList)
                // window.fileListQueue = queue

                if (newList.filter(file => !file.asyncStatus).length === 0) {

                    notification.open({
                        top: 100,
                        key: 'upload-list',
                        message: <>
                            <span style={{ fontWeight: 'blod' }}> 任务上传中</span>
                            <Spin wrapperClassName='black-spin' size='small' style={{ marginLeft: 10 }} />
                            <span style={{ color: '#ccc', marginLeft: 10 }}>成功0</span>
                            <span style={{ color: '#ccc', marginLeft: 10 }}>失败{newList.filter((item) => item.asyncStatus === 'error' || item.asyncStatus === 'fail').length}</span>
                            <span style={{ color: '#ccc', marginLeft: 10 }}>上传中{newList.filter((item) => item.asyncStatus === 'uploading').length}</span>
                        </>,
                        duration: 0,
                        description:
                            <UploadList data={newList} />,
                        onClick: () => {
                            console.log('Notification Clicked!');
                        },
                    });
                    // 如果全部上传失败
                    if (newList.filter((item) => item.asyncStatus === 'uploading').length === 0) {
                        const failList = newList.filter((item) => item.asyncStatus === 'error' || item.asyncStatus === 'fail')
                        const successCount = newList.filter((item) => item.asyncStatus === 'success').length
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            message: <>
                            </>,
                            duration: failList.length === 0 ? 3 : 0,
                            description:
                                <UploadList successCount={successCount} status='finish' data={failList} />,
                            onClick: () => {
                                console.log('Notification Clicked!');
                            },
                        });
                    }

                    // 上传完成不用更新列表，等待 socket 推送更新通知
                    // this.CarAndCardPicsTab._getPicsClassify();
                }
            }
            for (let i = 0; i < fileList.length; i++) {
                requestList.push(instance.exec(() => request(i), callBack)
                    .catch(err => {
                        // 这里是否catch(err)取决于是否允许某个任务失败时，其他任务继续执行
                        console.log(err)
                    })
                )
            }
            return Promise.all(requestList).then((res) => {
                startUploadStatusReconcile({
                    flowId,
                    onChange: (newList) => {
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            message: <>任务上传中 <Spin wrapperClassName='black-spin' size='small' style={{ marginLeft: 10 }} />
                                <span style={{ color: '#ccc', marginLeft: 10 }}>成功{newList.filter(item => item.asyncStatus === 'success').length}</span>
                                <span style={{ color: '#ccc', marginLeft: 10 }}>失败{newList.filter(item => ['error', 'fail'].includes(item.asyncStatus)).length}</span>
                                <span style={{ color: '#ccc', marginLeft: 10 }}>上传中{newList.filter(item => item.asyncStatus === 'uploading' || item.asyncStatus === '').length}</span>
                            </>,
                            duration: 0,
                            description: <UploadList data={newList} />,
                        });
                    },
                    onTimeout: (newList) => {
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            duration: 0,
                            message: '部分图片仍在后台处理中，请稍后刷新页面查看最终结果',
                            description: <UploadList data={newList} />,
                        });
                    },
                    onComplete: (newList) => {
                        window.postMessage({ security: true, eventName: 'refreshPicsClassify', flowId }, '*');
                        const failList = newList.filter(item => ['error', 'fail'].includes(item.asyncStatus));
                        notification.open({
                            top: 100,
                            key: 'upload-list',
                            duration: failList.length === 0 ? 3 : 0,
                            description: <UploadList successCount={newList.filter(item => item.asyncStatus === 'success').length} status='finish' data={failList} />,
                        });
                    },
                });
            })
                .catch(err => console.log(err))

        // 上传结束后 更新图片数据
        // console.log('isDone')
        // console.log(isDone)
     
     
    }
    changeCurrentCar = (value) => {
        this.setState({
            selectedLoss: value
        }, () => {
            window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
        })
        // 切换标的三者时更新图片列表

    }

    onSortStart = (sortItem) => {
        this.sortItem = sortItem;
    }
    onRecycleDrop = () => {
        deletePics({
            flowId: this.props.flowId,
            picIds: [this.sortItem._id]
        }).then(() => {
            message.success('删除成功');
            // 归类结束后更新图片列表
            window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
        })
    }
    onSuccess = () => {
        window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
    }
    handleDelete = () => {
        this.setState({
            recycleVisible: true
        })
    }
    render() {
        const {
            currentAgent,
            flowId,
            imgBasePath,
            currentReport
        } = this.props,
            { mediaCount, photos, selectedLoss, lossers, recycleVisible } = this.state, _this = this;

        const uploadPermission =
            !['checked', 'finished'].includes(currentReport.state) &&
            isShowLocalUploadButton(currentReport, currentAgent);
        return (
            // 任务中心
            <div className="car_or_cardpic_div" style={{ height: '100%', overflowY: 'auto', position: 'relative' }}>
                <div className="button-group">
                    <div style={{ display: 'none' }}>
                        {JSON.stringify(this.state.date)}
                    </div>
                    {/* 新增按钮 */}
                    {/* const TANANT_CPIC = 8 // 太平洋保险-饿了么

const TANANT_CPIC_DADA = 10 // 太平洋保险-达达

const TANANT_YINGDA_DANNIAO = 11; // 英达财险-丹鸟

const TANANT_CPIC_NANJING_DAPAIDANG = 12; // 江苏太保&南京大排档

const TANANT_PICC_YUANTONG = 13; // 人保-圆通-秒核

const TANANT_CIC_HALUO = 14; // 中华联合-哈啰

const TANANT_DAJIA_PORSCHE = 15; // 大家保险-保时捷

const TANANT_CCIC_HALUO = 16; // 大地财险-哈啰 */

                        // 登录坐席.agentRole.level === '2' //机构管理员
                        // 登录坐席.agentRole.level === '3' //公司管理员
                    }
                    {
                        currentAgent.tenant.code === 14 &&
                        (
                            currentAgent.agentRole.level === '2'
                            ||
                            currentAgent.agentRole.level === '3'
                        ) &&
                        ['checked'].includes(currentReport.state) &&
                        <Popconfirm

                            title="确定保司影像缺失并重新上传？"
                            okText="确定"
                            cancelText="取消"
                            onConfirm={this.confirm}

                        >
                            <Button type="link" style={{ color: 'red' }}>保司影像缺失?</Button>
                        </Popconfirm>
                    }
                    <Button style={{ marginRight: 5 }} onClick={this.showTreeData}>材料明细</Button>
                    <Button style={{ marginRight: 5 }} onClick={this.openWindow}>超级视图</Button>
                    <Button onClick={this.handleDownLoad.bind(this)} style={{ marginRight: 5 }}>{this.state.downloadBtnText}</Button>

                    {/*定损中心-本地上传按钮 */}
                    {
                        <Upload
                            name='file'
                            action='/api/lossAss/shotPics'
                            style={{ margin: '0 4px' }}
                            showUploadList={false}
                            multiple
                            accept='image/png,image/jpeg'
                            openFileDialogOnClick={!(window.newFileList && window.newFileList.some(item => item.asyncStatus === 'uploading'))}
                            beforeUpload={this.beforeLocalUpload}
                        >
                            {

                                isShowLocalUploadButton(currentReport, currentAgent)
                                &&
                                <Button
                                    
                                    type='primary'
                                    style={{ marginRight: 5 }}>
                                    本地上传
                                </Button>
                            }

                        </Upload>
                    }
                    <Button style={{ transition: 'all  0.1s', padding: '0 10px' }} onClick={this.handleDelete}>
                        <i className="iconfont icon-del-full"></i>
                    </Button>
                </div >
                <Tabs
                    destroyInactiveTabPane
                    onTabClick={this.tabClick.bind(this)}
                    activeKey={this.state.activeKey}
                    tabBarExtraContent={{
                        left: lossers && lossers.length ? <Select defaultValue={selectedLoss} value={selectedLoss} onChange={this.changeCurrentCar} style={{ width: 100, marginRight: 20 }}>
                            {
                                lossers.map(item => <Option key={item.lossId} value={item.lossId}>{item.name}</Option>)
                            }
                        </Select> : null
                    }}

                >
                    {
                        photos.map(photo => <TabPane tab={`${photo.name.replace('材料', '')}(${photo.picLen})`} key={photo.key}>
                            <CarPicturesList
                                carPictures={photo.list}
                                imgBasePath={imgBasePath}
                                tabKey={photo.key}
                                setPhotos={this.setPhotos}
                                disabled={true}
                                {...this.props}
                            />
                        </TabPane>)
                    }


                    <TabPane forceRender tab={`音视频(${mediaCount})`} key="mediaList">
                        <Suspense fallback={<div style={{ textAlign: 'center', margin: 20 }}>加载中...</div>}>
                            <Media
                                flowId={flowId}
                                getCount={this.getCount}
                                deleteVisible={false}
                                uploadVisible={uploadPermission}
                            />
                        </Suspense>
                    </TabPane>
                </Tabs>

                {
                    this.state.isShowTreeData ? <div className='materials-tree-data-container'>
                        <MaterialsTreeData
                            hideTreeData={this.hideTreeData}
                            flowId={flowId}
                            agentId={this.props.currentAgent._id}
                            from='loss-center'
                        />
                    </div> : null
                }

                {
                    recycleVisible ? <RecycleList visible={recycleVisible} flowId={flowId} onCancel={() => this.setState({ recycleVisible: false })} disabled={true} /> : null
                }
            </div>
        );
    }
}

export default withRouter(CarOrCardPic);
